import { render, staticRenderFns } from "./AdQuizTab.vue?vue&type=template&id=0a56ac78"
import script from "./AdQuizTab.vue?vue&type=script&lang=js"
export * from "./AdQuizTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports